<template>
  <div class="price_dialog">
    <el-dialog
      :title="$t('lang.价格调整')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      @selection-change="handleSelectionChange"
    >
      <el-radio-group
        v-model="radioPrice"
        class="select_radio"
        @change="changeRadioPrice"
      >
        <el-radio-button :label="$t('lang.电价')"></el-radio-button>
        <el-radio-button :label="$t('lang.水价')"></el-radio-button>
      </el-radio-group>

      <el-form class="bg_form">
        <el-form-item
          :label="
            radioPrice == $t('lang.水价')
              ? $t('lang.批量修改水价')
              : $t('lang.批量修改电价')
          "
        >
          <el-select v-model="priceId" :placeholder="$t('lang.请选择')">
            <el-option
              v-for="item in radioPrice == $t('lang.水价')
                ? waterPriceList
                : priceList"
              :key="item.priceId"
              :label="
                item.priceValue.toFixed(2) +
                monetary +
                (radioPrice == $t('lang.水价') ? '/m³' : '/kWh')
              "
              :value="item.priceId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :data="radioPrice == $t('lang.水价') ? tableDataWater : tableData"
        @selection-change="handleSelectionChange"
        height="250"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          v-for="item in priceLabel"
          :key="item.prop"
          :label="
            item.prop == 'price'
              ? `${$t('lang.' + item.label)}(${monetary})`
              : $t('lang.' + item.label)
          "
          :prop="item.prop"
          :min-width="item.width"
          :formatter="formatter"
        ></el-table-column>
      </el-table>
      <div class="payment_bottom">
        <el-pagination
          layout="prev, pager, next"
          :total="params.totalCount"
          :page-size="params.pageSize"
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("lang.取消") }}</el-button>
        <el-button type="primary" @click="onClickSave">
          {{ $t("lang.保存") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { priceLabel } from "../define.js";
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      radioPrice: this.$t("lang.电价"),
      dialogVisible: false,
      priceLabel: priceLabel,
      priceList: [],
      waterPriceList: [],
      priceId: "",
      tableData: [],
      tableDataWater: [],
      pointIdList: [],
      selPriceList: [],
      monetary: "元",
      //#region 分页
      params: {
        pageNum: 1,
        pageSize: 100,
        totalCount: 0,
      },
      tableAllEleData: [],
      tableAllWatData: [],
      //#endregion
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      hierarchicalPrice: "ZD_HierarchicalPrice",
      hierarchicalWaterPrice: "ZD_HierarchicalWaterPrice",
      batchModificationOfPrices: "ZD_BatchModificationOfPrices",
      waterBatchModificationOfPrices: "ZD_WaterBatchModificationOfPrices",
    }),
    handleClose() {
      this.dialogVisible = false;
    },
    formatter(row, { property }) {
      if (row[property]) {
        return row[property];
      } else {
        return "--";
      }
    },
    async showDialog() {
      this.params.pageNum = 1;
      this.radioPrice = this.$t("lang.电价");
      this.monetary = localStorage.getItem("monetary");
      this.dialogVisible = true;
      let res = await this.hierarchicalPrice({
        rootId: this.$parent.queryForm.rootId,
        successCheckType: 1,
      });
      if (res.success !== 1) return;
      let resWater = await this.hierarchicalWaterPrice({
        rootId: this.$parent.queryForm.rootId,
        successCheckType: 1,
      });
      if (resWater.success !== 1) return;
      this.tableAllEleData = res.listitem || [];
      this.tableAllEleData.forEach((item) => {
        item.price = item.price.toFixed(2);
      });
      this.tableData = this.tableAllEleData.slice(0, 100);
      this.params.totalCount = res.totalItemCount;

      this.tableAllWatData = resWater.listitem || [];
      this.tableAllWatData.forEach((item) => {
        item.price = item.price.toFixed(2);
      });
      this.tableDataWater = this.tableAllWatData.slice(0, 100);
      this.changeRadioPrice();
    },
    changeRadioPrice() {
      this.priceId = "";
      this.params.pageNum = 1;
      if (this.radioPrice === this.$t("lang.电价")) {
        this.tableData = this.tableAllEleData.slice(
          (this.params.pageNum - 1) * this.params.pageSize,
          this.params.pageNum * this.params.pageSize
        );
        this.params.totalCount = this.tableAllEleData.length;
      } else {
        this.tableDataWater = this.tableAllWatData.slice(
          (this.params.pageNum - 1) * this.params.pageSize,
          this.params.pageNum * this.params.pageSize
        );
        this.params.totalCount = this.tableAllWatData.length;
      }
    },
    handleSelectionChange(val) {
      this.pointIdList = val.map((item) => item.pointId);
      this.selPriceList = val;
    },
    async onClickSave() {
      switch (this.radioPrice) {
        case this.$t("lang.电价"):
          if (this.priceId == "") {
            this.$message({
              type: "error",
              message: this.$t("lang.请选择电价方案"),
            });
            return;
          }
          if (this.pointIdList.length == 0) {
            this.$message({
              type: "error",
              message: this.$t("lang.请选择设备"),
            });
            return;
          }
          let params = {
            value: {
              pointIdList: this.pointIdList,
              price: 0,
              priceId: this.priceId,
              rootId: this.$parent.queryForm.rootId,
            },
          };
          params.value.price = this.priceList.find(
            (item) => item.priceId == this.priceId
          ).priceValue;
          let priceJudgment = 0;
          this.selPriceList.forEach((item) => {
            if (item.price == params.value.price) {
              priceJudgment += 1;
            }
          });
          if (priceJudgment == this.pointIdList.length) {
            this.$message({
              type: "error",
              message: this.$t("lang.所选设备价格与修改价格一致无需修改"),
            });
            return;
          }
          let res = await this.batchModificationOfPrices(params);
          if (res.success !== 1) return;
          this.handleClose();
          this.$message({
            type: "success",
            message: this.$t("lang.修改成功"),
          });
          break;
        case this.$t("lang.水价"):
          if (this.priceId == "") {
            this.$message({
              type: "error",
              message: this.$t("lang.请选择水价方案"),
            });
            return;
          }
          if (this.pointIdList.length == 0) {
            this.$message({
              type: "error",
              message: this.$t("lang.请选择设备"),
            });
            return;
          }
          let waterParams = {
            value: {
              pointIdList: this.pointIdList,
              price: 0,
              priceId: this.priceId,
              rootId: this.$parent.queryForm.rootId,
            },
          };
          waterParams.value.price = this.waterPriceList.find(
            (item) => item.priceId == this.priceId
          ).priceValue;
          let waterPriceJudgment = 0;
          this.selPriceList.forEach((item) => {
            if (item.price == waterParams.value.price) {
              waterPriceJudgment += 1;
            }
          });
          if (waterPriceJudgment == this.pointIdList.length) {
            this.$message({
              type: "error",
              message: this.$t("lang.所选设备价格与修改价格一致无需修改"),
            });
            return;
          }
          let resWater = await this.waterBatchModificationOfPrices(waterParams);
          if (resWater.success !== 1) return;
          this.handleClose();
          this.$message({
            type: "success",
            message: this.$t("lang.修改成功"),
          });
          break;
        default:
          break;
      }
    },
    //#region 分页
    handleCurrentChange(val) {
      this.params.pageNum = val;
      if (this.radioPrice === this.$t("lang.电价")) {
        this.tableData = this.tableAllEleData.slice(
          (this.params.pageNum - 1) * this.params.pageSize,
          this.params.pageNum * this.params.pageSize
        );
      } else {
        this.tableDataWater = this.tableAllWatData.slice(
          (this.params.pageNum - 1) * this.params.pageSize,
          this.params.pageNum * this.params.pageSize
        );
      }
    },
    //#endregion
  },
};
</script>

<style scoped lang='less'>
.price_dialog {
  .payment_bottom {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  /deep/ .el-dialog__footer {
    padding-top: 30px;
  }
  /deep/ .el-dialog__header {
    padding-bottom: 20px;
  }
}
/deep/ .el-dialog {
  width: 867px;
}
/deep/ .el-dialog__body {
  padding: 0 100px;
}
.bg_form {
  padding-top: 20px;
}
.select_radio {
  padding-top: 20px;
}
</style>
